import { render, staticRenderFns } from "./direct-sales-proposals-complete.page.vue?vue&type=template&id=155b98de&scoped=true"
import script from "./direct-sales-proposals-complete.page.vue?vue&type=script&lang=ts"
export * from "./direct-sales-proposals-complete.page.vue?vue&type=script&lang=ts"
import style0 from "./direct-sales-proposals-complete.page.vue?vue&type=style&index=0&id=155b98de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b98de",
  null
  
)

export default component.exports